import { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { EditableTitle } from '@/shared/ui';
import { EmployeeGroupFormValues } from './types';

type Props = {
  isCreate: boolean;
  onUpdateName?: (name: string) => void;
  disabled?: boolean;
};

/**
 * Inline-редактирование названия группы операторов.
 * В режиме создания изменения сохраняются только в форме; в режиме редактирования
 * при изменении имени дополнительно вызывается onUpdateName для немедленного PUT.
 */
export const EditableGroupTitle: FC<Props> = ({ isCreate, onUpdateName, disabled }) => {
  const { t } = useTranslation(['employees']);
  const { setValue } = useFormContext<EmployeeGroupFormValues>();
  const nameValue = useWatch({ name: 'name' });

  const handleSave = (newValue: string) => {
    setValue('name', newValue, { shouldDirty: true });
    if (isCreate) return;
    if (newValue && newValue !== nameValue && onUpdateName) {
      onUpdateName(newValue);
    }
  };

  return (
    <EditableTitle
      value={nameValue ?? ''}
      label={t('employees:groups.renameGroup')}
      placeholder={isCreate ? t('employees:groups.newGroup') : ''}
      disabled={disabled}
      onSave={handleSave}
      fixedInputWidth
    />
  );
};
